import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='insurance'
      advisorImageVariant='advisorF'
      headingText={<>Ready to find the right insurance coverage <WidowBlock>for you&#63;</WidowBlock></>}
      text='Our advisors are here to recommend the right types, and right amount, of insurance to fit your goals and budget.'
    />
  );
};
